/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
// import {TSendPhoneNumberInput} from 'graphql/types/login';
// import {GET_LOCK_USER_TIME} from 'graphql/schema/user';
// import {useLazyQuery} from '@apollo/client';
import { OTP_TIMEOUT, PHONE_NUMBER_LEN, SECS, VN_PHONE } from '../common/constants';

export interface IUserContext {
  phoneNumber: string;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  isRequestOtp: boolean;
  setIsRequestOtp: React.Dispatch<React.SetStateAction<boolean>>;
  isLoginWithPin: boolean;
  setIsLoginWithPin: React.Dispatch<React.SetStateAction<boolean>>;
  isLock: boolean;
  setIsLock: React.Dispatch<React.SetStateAction<boolean>>;
  timer: number;
  setTimer: React.Dispatch<React.SetStateAction<number>>;
  intervalId: NodeJS.Timer | undefined;
  setIntervalId: React.Dispatch<React.SetStateAction<NodeJS.Timer | undefined>>;
  remainTimer: number;
  isGetTime: boolean;
  setIsGetTime: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UserContext = React.createContext<IUserContext | null>(null);

export const UserProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const [phoneNumber, setPhoneNumber] = React.useState<string>('');
  const [isRequestOtp, setIsRequestOtp] = React.useState<boolean>(false);
  const [remainLockTime, setRemainLockTime] = React.useState<number>(0);
  const [isLoginWithPin, setIsLoginWithPin] = React.useState<boolean>(false);
  const [isLock, setIsLock] = React.useState<boolean>(false);
  const [isGetTime, setIsGetTime] = React.useState<boolean>(false);
  const [intervalId, setIntervalId] = React.useState<NodeJS.Timer>();
  const [timer, setTimer] = React.useState<number>(OTP_TIMEOUT * 60 * SECS);
  const [remainTimer, setRemainTimer] = React.useState<number>(0);
  React.useMemo(() => {
    if (phoneNumber.length === 0) {
      return;
    }
    const id = setInterval(() => {
      setTimer(prev => {
        return prev - SECS;
      });
    }, SECS);
    setIntervalId(id);
  }, [isRequestOtp]);

  // const [getLockRemainingTime] = useLazyQuery<
  //   {getUserRemainLockTime: number},
  //   TSendPhoneNumberInput
  // >(GET_LOCK_USER_TIME, {
  //   fetchPolicy: 'network-only',
  // });

  const getRemainTime = async () => {
    console.log('getRemainTime: ', VN_PHONE + phoneNumber);
    // const result = await getLockRemainingTime({
    //   variables: {
    //     phoneNumber: VN_PHONE + phoneNumber,
    //   },
    // });
    // const time = result.data?.getUserRemainLockTime;
    const time = 120 * SECS;
    console.log('time: ', time);
    if (time && time !== 0) {
      setRemainLockTime(time);
      setRemainTimer(time);
    } else {
      setIsLock(false);
    }
    setIsGetTime(false);
  };

  React.useMemo(() => {
    if (remainLockTime !== 0) {
      setInterval(() => {
        setRemainTimer(prev => {
          return prev - SECS;
        });
      }, SECS);
    } else {
      setIsLock(false);
    }
  }, [remainLockTime]);

  React.useMemo(() => {
    if (phoneNumber.length !== PHONE_NUMBER_LEN - 1 || !isGetTime) {
      return;
    }
    getRemainTime();
  }, [phoneNumber, isLock, isGetTime]);

  const data = {
    phoneNumber,
    setPhoneNumber,
    isRequestOtp,
    setIsRequestOtp,
    timer,
    setTimer,
    intervalId,
    setIntervalId,
    isLoginWithPin,
    setIsLoginWithPin,
    remainTimer,
    isLock,
    setIsLock,
    isGetTime,
    setIsGetTime,
  };
  return <UserContext.Provider value={data}>{children}</UserContext.Provider>;
};
